import React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";
import { keyframes } from "@emotion/react";

interface OverclockedGaugeIconProps extends SvgIconProps {
  active?: boolean;
}

const OverclockedGaugeIcon: React.FC<OverclockedGaugeIconProps> = ({
  active = false,
  sx,
  ...props
}) => {
  const inactiveColor = "#ccc";
  const activeColor = "#ff1744"; // bright red

  const pulse = keyframes`
      0% { stroke-opacity: 1; transform: scale(1); }
      50% { stroke-opacity: 0.6; transform: scale(1.02); }
      100% { stroke-opacity: 1; transform: scale(1); }
    `;

  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{
        ...sx,
        transition: "all 0.3s ease-in-out",
        path: active
          ? {
              animation: `${pulse} 1.2s infinite ease-in-out`,
              transformOrigin: "center center",
            }
          : {},
      }}
      {...props}
    >
      {/* Outer Circle */}
      <circle
        cx="32"
        cy="32"
        r="30"
        fill="none"
        stroke="#555"
        strokeWidth="4"
      />

      {/* Full Animated Circle */}
      <circle
        cx="32"
        cy="32"
        r="24"
        fill="none"
        stroke={active ? activeColor : inactiveColor}
        strokeWidth="6"
      />

      {/* Gauge Needle (pointing right) */}
      <line
        x1="32"
        y1="32"
        x2="52"
        y2="32"
        stroke="#333"
        strokeWidth="4"
        strokeLinecap="round"
      />

      {/* Center Circle */}
      <circle cx="32" cy="32" r="4" fill="#333" />
    </SvgIcon>
  );
};

interface ChildProps {
  isActive: boolean;
}

const OverclockedGauge = ({ isActive }: ChildProps) => {
  const theme = useTheme();
  const fontSize = theme.palette.mode === "dark" ? "24px" : "20px";
  
  return <OverclockedGaugeIcon active={isActive} sx={{ fontSize }} />;
};

export default OverclockedGauge;
